import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NotFoundComponent } from '../detail/not-found';
import { Grid } from '@material-ui/core';
import { Btn, Bx, DateTimeControl, Input, OutlinedInputControl, Typo, useBreakpoints } from '@curry-group/mui-curcuma';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownLeft, faDownload, faMailbox } from '@fortawesome/pro-light-svg-icons';
import { HeadlineContainer } from '../headline-container';
import { useAcademicTitles } from '../../data/sagas/lists';
import { useGetAllGroups } from '../../data/sagas/userprofile';
import { FormDateTime, TimeSpan } from '../form/controls/date-time-select';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DayjsUtils from '@date-io/dayjs';
import { api } from '../../data/api';

export interface IDSAComponentProps { }

export const DSAComponent: React.FC<IDSAComponentProps> = () => {
  useAcademicTitles();
  useGetAllGroups();
  const breakpoints = useBreakpoints();
  const dispatch = useDispatch();

  const [selectedDateStart, setSelectedDateStart] = React.useState<Date | null>(new Date());
  const [selectedDateEnd, setSelectedDateEnd] = React.useState<Date | null>(new Date());

  const isAdmin = useSelector(state => state.foundation?.profile?.isAdmin);
  const isMdUp = breakpoints.mdUp || false;
  const expertRegisteredMessage = useSelector(state => state.userProfile?.expertRegisteredMessage);

  if (!isAdmin) {
    return (<NotFoundComponent />); 
  }

  const downloadDataOnClick = async (fromDate, toDate) => {
    const params = { from: fromDate, to: toDate, timePeriod: "monthly" };
    const options = {
      method: 'POST',
      body: JSON.stringify(params),
      headers: { 'content-type': 'application/json' }
    };
    
    await fetch(api.v1.profile.csvdata, options).then(response => {
      response
        .text()
        .then(result => {
          const blob = new Blob([result], { type: 'text/csv' });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          document.body.appendChild(link);
          const dlName = encodeURIComponent('Nutzerzahlen.csv');
          link.download = dlName;
          link.target = '_blank';
          link.href = url;
          link.click();
          document.body.removeChild(link);
        })
        .catch(() => {
          alert('Download failed, please contact Admin!');
        });
    });
  };

  return (<MuiPickersUtilsProvider utils={DayjsUtils} locale="de">
    <Bx mb={6}>
      <HeadlineContainer
        mb={4}
        headline="Aktuelle Daten zu DSA abrufen"
        headlineVariant={isMdUp ? 'h3boosted' : 'h3'}
        endAdornment={<>
        </>}
      />
      <Bx mb={2}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Input
              inputLabel={{
                children: 'Beginn *'
              }}
              inputComponent={
                <DateTimeControl
                  value={selectedDateStart}
                  onChange={val => {
                    setSelectedDateStart(val ? val.toDate() : null);
                  }}
                  TextFieldComponent={OutlinedInputControl}
                  variant="inline"
                  format="DD.MM.YYYY HH:mm"
                />
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              inputLabel={{
                children: 'Ende *'
              }}
              inputComponent={
                <DateTimeControl
                  value={selectedDateEnd}
                  onChange={val => {
                    setSelectedDateEnd(val ? val.toDate() : null);
                  }}
                  TextFieldComponent={OutlinedInputControl}
                  variant="inline"
                  format="DD.MM.YYYY HH:mm"
                  minDate={selectedDateStart}
                />
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={6} md={6}>
            <Btn size="large"
              startIcon={<FontAwesomeIcon icon={faDownload} />}
              variant="outlined"
              onClick={()=>{
                downloadDataOnClick(selectedDateStart, selectedDateEnd);
              }}
            >
              Daten herunterladen
            </Btn>
          </Grid>
        </Grid>
        <Grid container spacing={4}>
          <Grid item xs={6} md={6}>
            <Bx mb={2}><Typo component='span' variant='body2' fontWeight={500}>{expertRegisteredMessage ?? ' '}</Typo></Bx>
          </Grid>
        </Grid>
      </Bx>
    </Bx>
  </MuiPickersUtilsProvider>);
};
